/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import {
  faChevronDown,
  faChevronUp,
  faFileAlt,
  faPlusSquare,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"

import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
import queryString from "query-string"
import { useEffect, useRef, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"

import dayjs from "dayjs"
import { generatePath, useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."

import AlertComponent from "../../../components/AlertComponent"

import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import ZyomuinKyuyoService from "../../../service/driverpayroll/zyomuinKyuyo/zyomuinKyuyoService"
import {
  TZyomuinKyuyoInfoGetRes,
  TZyomuinKyuyoListGetReq,
  TZyomuinKyuyoZissekiPutReq,
  T乗務員給与,
} from "../../../service/driverpayroll/zyomuinKyuyo/TZyomuinKyuyo"

import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"

import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"
import { RootState } from "../../../globalStore/rootreducer"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import BusyoService from "../../../service/master/busyo/busyoService"
import MonthInput from "../../../components/InputWrapper/MonthInput"
import ComboBox from "../../../components/ComboBox"
import Decimal from "decimal.js"
import { zyomuinKyuyoActions } from "../../../globalStore/pageStore/zyomuinKyuyoStore/zyomuinKyuyoStore"
import { showInfoToast } from "../../../components/CustomToast"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import commonUtil from "../../../ts/util/commonUtil"
import VALIDATE_CONSTANT from "../../../constant/validateConstant"
import KadoTyoseiRegisterModal from "./KadoTyoseiRegisterModal"
import { eレコード種別 } from "../../../constant/enum/frontend"
import { TApiResponse } from "../../../service/TApiResponse"
import { FunctionContext } from "../../../components/Context"
import { saveAs } from "file-saver"
import util from "../../../ts/util"
import { メニューコード } from "../../../constant/menuCode"

interface IGridFields {
  勤怠日数_出勤: number
  勤怠日数_休出: number
  勤怠日数_祝出: number
  勤怠日数_特休: number
  勤怠日数_有休: number
  就労時間_勤務時間: number
  就労時間_残業時間: number
  就労時間_深夜時間: number
  就労時間_休出時間: number
  給与明細_基本給: number
  給与明細_住宅手当: number
  給与明細_能力開発: number
  給与明細_稼働手当: number
  給与明細_残業手当: number
  給与明細_有休補償: number
  給与明細_深夜残業他: number
  給与明細_休日手当: number
  給与明細_通勤手当課: number
  給与明細_通勤手当非: number
  給与明細_業務手当他: number
  給与明細_評価割増: number
  給与明細_残業割増額: number
  給与明細_深夜割増額: number
  給与明細_休日割増額: number

  // 手入力も行う
  is手当編集Checked: boolean
  給与明細_地域調整手当: number
  給与明細_業務手当: number

  // 月報情報
  給与明細_旅費: number
  給与明細_月報稼働手当: number

  // Excel取込
  給与明細_稼働調整: number
}

type T乗務員給与一覧Grid = TZyomuinKyuyoInfoGetRes & IGridFields

const 編集可能CellBindings: (keyof T乗務員給与一覧Grid)[] = [
  "給与明細_地域調整手当",
  "給与明細_業務手当",
]

// マスタの乗務員給与_地域調整用最低賃金を利用しなくなったため、
const calc給与明細_地域調整手当 = (i: T乗務員給与) =>
  i.給与実績_地域調整手当 ?? 0

const calc給与明細_業務手当 = (i: T乗務員給与) => {
  if (i.実績表示フラグ) {
    return i.給与実績_業務手当
  } else {
    const c乗務員給与_業務手当 = new Decimal(i.乗務員給与_業務手当 ?? 0)
    const c乗務員給与_その他手当 = new Decimal(i.乗務員給与_その他手当 ?? 0)
    const c月報_特別手当 = new Decimal(i.特別手当 ?? 0)
    const c月報_その他手当 = new Decimal(i.その他手当 ?? 0)

    return c乗務員給与_業務手当
      .plus(c乗務員給与_その他手当)
      .plus(c月報_特別手当)
      .plus(c月報_その他手当)
      .toNumber()
  }
}

/**
 * 乗務員給与一覧
 * @returns
 */
const ZyomuinKyuyoList = () => {
  const history = useHistory()
  const location = useLocation()
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr)

  // 稼働調整Modal用
  const ref年月 = useRef<string>(eigyobi)

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "ZyomuinKyuyoList_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TZyomuinKyuyoInfoGetRes & Partial<IGridFields>>,
    pageSize: number
  ) =>
    new wjCore.CollectionView(
      [
        ...data.map((d) => ({
          ...d,
          給与明細_地域調整手当:
            d.給与明細_地域調整手当 ?? calc給与明細_地域調整手当(d),
          給与明細_業務手当: d.給与明細_業務手当 ?? calc給与明細_業務手当(d),
          is手当編集Checked: d.is手当編集Checked,
        })),
      ],
      {
        pageSize,

        // TODO:運行月報の値を計算式に反映する必要がある。
        calculatedFields: {
          // sort
          sort_部所コード: (i: T乗務員給与一覧Grid) =>
            commonUtil.createSortString(
              i.部所コード,
              VALIDATE_CONSTANT.LENGTH.部所コード
            ),
          sort_社員コード: (i: T乗務員給与一覧Grid) =>
            commonUtil.createSortString(
              i.社員コード,
              VALIDATE_CONSTANT.LENGTH.社員コード
            ),

          // 各値をPG算出か実績DBの値から設定
          勤怠日数_出勤: (i: T乗務員給与一覧Grid) => {
            if (i.実績表示フラグ) {
              return i.給与実績_出勤日数 ?? 0
            } else {
              return i.出勤日数 ?? 0
            }
          },
          勤怠日数_休出: (i: T乗務員給与一覧Grid) => {
            if (i.実績表示フラグ) {
              return i.給与実績_休出日数 ?? 0
            } else {
              return i.休出日数 ?? 0
            }
          },
          勤怠日数_祝出: (i: T乗務員給与一覧Grid) => {
            if (i.実績表示フラグ) {
              return i.給与実績_祝出日数 ?? 0
            } else {
              return i.祝出日数 ?? 0
            }
          },
          勤怠日数_特休: (i: T乗務員給与一覧Grid) => {
            if (i.実績表示フラグ) {
              return i.給与実績_特休日数 ?? 0
            } else {
              return i.特休日数 ?? 0
            }
          },
          勤怠日数_有休: (i: T乗務員給与一覧Grid) => {
            if (i.実績表示フラグ) {
              return i.給与実績_有休日数 ?? 0
            } else {
              return i.有休日数 ?? 0
            }
          },

          就労時間_勤務時間: (i: T乗務員給与一覧Grid) => {
            if (i.実績表示フラグ) {
              // 実績DBはミリ秒になってるので戻して使う。
              const c勤務時間 = new Decimal(i.給与実績_勤務時間 ?? 0)
              const ミリ秒 = new Decimal(3600000)

              return c勤務時間.div(ミリ秒).toNumber()
            } else {
              // 所定時間マスタと就労時間の比較により値を返却
              if (i.就労時間 > i.所定時間マスタ_所定時間) {
                return i.所定時間マスタ_所定時間 ?? 0
              } else {
                return i.就労時間 ?? 0
              }
            }
          },
          就労時間_残業時間: (i: T乗務員給与一覧Grid) => {
            if (i.実績表示フラグ) {
              // 実績DBはミリ秒になってるので戻して使う。
              const c残業時間 = new Decimal(i.給与実績_残業時間 ?? 0)
              const ミリ秒 = new Decimal(3600000)

              return c残業時間.div(ミリ秒).toNumber()
            } else {
              // 所定時間マスタと就労時間の比較により値を返却
              if (i.就労時間 > i.所定時間マスタ_所定時間) {
                const c就労時間 = new Decimal(i.就労時間 ?? 0)
                const c所定時間 = new Decimal(i.所定時間マスタ_所定時間)

                return c就労時間.minus(c所定時間).toNumber()
              } else {
                return 0
              }
            }
          },
          就労時間_深夜時間: (i: T乗務員給与一覧Grid) => {
            if (i.実績表示フラグ) {
              // 実績DBはミリ秒になってるので戻して使う。
              const c深夜時間 = new Decimal(i.給与実績_深夜時間 ?? 0)
              const ミリ秒 = new Decimal(3600000)

              return c深夜時間.div(ミリ秒).toNumber()
            } else {
              return i.深夜時間 ?? 0
            }
          },
          就労時間_休出時間: (i: T乗務員給与一覧Grid) => {
            if (i.実績表示フラグ) {
              // 実績DBはミリ秒になってるので戻して使う。
              const c休出時間 = new Decimal(i.給与実績_休出時間 ?? 0)
              const ミリ秒 = new Decimal(3600000)

              return c休出時間.div(ミリ秒).toNumber()
            } else {
              return i.休出時間 ?? 0
            }
          },

          // 支給明細は給与実績が存在しない場合、PG計算した値を返却
          給与明細_基本給: (i: T乗務員給与一覧Grid) => {
            if (i.実績表示フラグ) {
              return i.給与実績_基本給
            } else {
              const c勤務時間 = new Decimal(i.就労時間_勤務時間 ?? 0)
              const c基本給 = new Decimal(i.乗務員給与_基本給 ?? 0)

              return c勤務時間.times(c基本給).toNumber()
            }
          },
          給与明細_住宅手当: (i: T乗務員給与一覧Grid) => {
            if (i.実績表示フラグ) {
              return i.給与実績_住宅手当
            } else {
              return i.乗務員給与_住宅手当 ?? 0
            }
          },
          給与明細_能力開発: (i: T乗務員給与一覧Grid) => {
            if (i.実績表示フラグ) {
              return i.給与実績_能力開発
            } else {
              return i.乗務員給与_能力開発 ?? 0
            }
          },

          給与明細_稼働手当: (i: T乗務員給与一覧Grid) => {
            if (i.実績表示フラグ) {
              return i.給与実績_稼働手当
            } else {
              // Excel取込した稼働調整と月報の稼働手当から算出
              const c月報稼働手当 = new Decimal(i.給与明細_月報稼働手当 ?? 0)
              const c稼働調整 = new Decimal(i.給与明細_稼働調整 ?? 0)

              return c月報稼働手当.plus(c稼働調整).toNumber()
            }
          },
          給与明細_残業手当: (i: T乗務員給与一覧Grid) => {
            if (i.実績表示フラグ) {
              return i.給与実績_残業手当
            } else {
              const c残業割増額 = new Decimal(i.給与明細_残業割増額 ?? 0)
              const c深夜割増額 = new Decimal(i.給与明細_深夜割増額 ?? 0)
              const c休日割増額 = new Decimal(i.給与明細_休日割増額 ?? 0)

              return c残業割増額.plus(c深夜割増額).plus(c休日割増額).toNumber()
            }
          },

          給与明細_休日手当: (i: T乗務員給与一覧Grid) => {
            if (i.実績表示フラグ) {
              return i.給与実績_休日手当
            } else {
              const c休出日数 = new Decimal(i.休出日数 ?? 0)
              const c祝出日数 = new Decimal(i.祝出日数 ?? 0)
              // 休出 + 祝出
              const c休日日数 = c休出日数.plus(c祝出日数)
              const c休日手当単価 = new Decimal(i.乗務員給与_休日手当 ?? 0)

              return c休日日数.times(c休日手当単価).toNumber()
            }
          },
          給与明細_評価割増: (i: T乗務員給与一覧Grid) => {
            if (i.実績表示フラグ) {
              return i.給与実績_評価割増
            } else {
              return i.乗務員給与_評価割増 ?? 0
            }
          },
          給与明細_有休補償: (i: T乗務員給与一覧Grid) => {
            if (i.実績表示フラグ) {
              return i.給与実績_有休補償
            } else {
              const c有休日数 = new Decimal(i.有休日数 ?? 0)
              const c特休日数 = new Decimal(i.特休日数 ?? 0)
              const c時間 = new Decimal(8)
              const c基本給 = new Decimal(i.乗務員給与_基本給 ?? 0)
              // 【乗務員】((有休日数+特休日数)×８時間）×基本給【乗務員給与マスタ】（有休を使用した補償金額）
              return c有休日数
                .add(c特休日数)
                .times(c時間)
                .times(c基本給)
                .toNumber()
            }
          },
          給与明細_通勤手当課: (i: T乗務員給与一覧Grid) => {
            if (i.実績表示フラグ) {
              return i.給与実績_通勤手当課
            } else {
              return i.乗務員給与_通勤費_課税 ?? 0
            }
          },
          給与明細_通勤手当非: (i: T乗務員給与一覧Grid) => {
            if (i.実績表示フラグ) {
              return i.給与実績_通勤手当非
            } else {
              return i.乗務員給与_通勤費_非課税 ?? 0
            }
          },
          給与明細_旅費: (i: T乗務員給与一覧Grid) => {
            if (i.実績表示フラグ) {
              return i.給与実績_旅費
            } else {
              return i.食事手当 ?? 0
            }
          },
          給与明細_月報稼働手当: (i: T乗務員給与一覧Grid) => {
            if (i.実績表示フラグ) {
              return i.給与実績_月報稼働手当
            } else {
              // 月報からの集計値
              return i.稼働手当 ?? 0
            }
          },
          給与明細_稼働調整: (i: T乗務員給与一覧Grid) => {
            if (i.実績表示フラグ) {
              return i.給与実績_稼働調整
            } else {
              // 稼働調整貼り付けDBの値
              return i.取込_稼働調整 ?? 0
            }
          },
          給与明細_残業割増額: (i: T乗務員給与一覧Grid) => {
            if (i.実績表示フラグ) {
              return i.給与実績_残業割増額
            } else {
              const c時間 = new Decimal(i.就労時間_残業時間 ?? 0)
              const c単価 = new Decimal(i.乗務員給与_時間外単価 ?? 0)

              return c時間.times(c単価).toNumber()
            }
          },
          給与明細_深夜割増額: (i: T乗務員給与一覧Grid) => {
            if (i.実績表示フラグ) {
              return i.給与実績_深夜割増額
            } else {
              // calculatedFieldsで日数⇒時間変換した値を使用する。
              const c時間 = new Decimal(i.就労時間_深夜時間 ?? 0)

              // 単価設定
              const c単価 = new Decimal(i.乗務員給与_深夜残単価 ?? 0)

              // 単価を掛けて返却
              return c時間.times(c単価).toNumber()
            }
          },
          給与明細_休日割増額: (i: T乗務員給与一覧Grid) => {
            if (i.実績表示フラグ) {
              return i.給与実績_休日割増額
            } else {
              const c日曜出勤数 = new Decimal(i.日曜出勤数 ?? 0)
              const c時間 = new Decimal(8)
              const c単価 = new Decimal(i.乗務員給与_日曜残単価 ?? 0)

              return c日曜出勤数.times(c時間).times(c単価).toNumber()
            }
          },

          // 支給明細の科目を重複しないよう集計
          支給合計: (i: T乗務員給与一覧Grid) => {
            const c基本給 = new Decimal(i.給与明細_基本給 ?? 0)
            const c住宅手当 = new Decimal(i.給与明細_住宅手当 ?? 0)
            const c能力開発 = new Decimal(i.給与明細_能力開発 ?? 0)
            const c地域調整手当 = new Decimal(i.給与明細_地域調整手当 ?? 0)
            // 月報稼働手当+稼働調整
            const c稼働手当 = new Decimal(i.給与明細_稼働手当 ?? 0)
            // 割増額３種(残業、深夜、休日)
            const c残業手当 = new Decimal(i.給与明細_残業手当 ?? 0)
            // (月報:特別手当+その他手当)+(手当マスタ:業務手当+その他手当)
            const c業務手当 = new Decimal(i.給与明細_業務手当 ?? 0)
            const c評価割増 = new Decimal(i.給与明細_評価割増 ?? 0)
            const c有休補償 = new Decimal(i.給与明細_有休補償 ?? 0)
            const c通勤手当課 = new Decimal(i.給与明細_通勤手当課 ?? 0)
            const c通勤手当非 = new Decimal(i.給与明細_通勤手当非 ?? 0)
            const c旅費 = new Decimal(i.給与明細_旅費 ?? 0)
            const c休日手当 = new Decimal(i.給与明細_休日手当 ?? 0)

            return c基本給
              .plus(c住宅手当)
              .plus(c能力開発)
              .plus(c地域調整手当)
              .plus(c稼働手当)
              .plus(c残業手当)
              .plus(c業務手当)
              .plus(c評価割増)
              .plus(c有休補償)
              .plus(c通勤手当課)
              .plus(c通勤手当非)
              .plus(c旅費)
              .plus(c休日手当)
              .toNumber()
          },
        },

        sortDescriptions: [
          new wjCore.SortDescription("sort_部所コード", true),
          new wjCore.SortDescription("sort_社員コード", true),
        ],

        // GridFooterからのイベント伝達用
        onPageChanged() {
          if (flexGrid && flexGrid.itemsSource) {
            const pageIndex = flexGrid!.itemsSource!.pageIndex
            setPageNumber(pageIndex)
          }
        },
      }
    )

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TZyomuinKyuyoListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    disPatch(clearAlert()) // アラートを非表示に
    setIsSearched(false)

    let currentSearchCondition: TZyomuinKyuyoListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }

    if (currentSearchCondition == null) return
    setPreSearchCondition({ ...currentSearchCondition })

    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new ZyomuinKyuyoService().getList(
        currentSearchCondition
      )

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
      setIsSearched(true)
      // 稼働調整Modal用にRefに年月を保存
      ref年月.current = currentSearchCondition.年月 ?? eigyobi
    } catch (error) {
      // dispatch(setAlerts(error))
      disPatch(setWarningAlerts(["エラー表示"]))
      setIsSearched(false)
    } finally {
      setIsSearching(false) // 検索中状態に遷移
      flexGrid?.refresh()
      set再計算済みフラグ(false)
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TZyomuinKyuyoListGetReq = queryString.parse(location.search)
    set年月(query.年月)
    set部所コード(query.部所コード)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TZyomuinKyuyoListGetReq => {
    return {
      年月: 年月 ?? new Date().toISOString(),
      部所コード: 部所コード ?? undefined,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TZyomuinKyuyoListGetReq
  ) => {
    const disp年月 = dayjs(searchCondition.年月).format("YYYY/MM")

    const disp部所 = 部所ItemSource?.find(
      (i) => i.部所コード === searchCondition.部所コード
    )
    return {
      年月: wjCore.isNullOrWhiteSpace(disp年月 ?? "") ? "" : disp年月,
      部所: disp部所
        ? `${disp部所.部所コード} ${disp部所.部所略称}`
        : undefined,
    }
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    // ヘッダーに行追加
    // header行に一行追加
    // 追加行のみ初期化時に設定
    let extraRow = new wjGrid.Row()
    extraRow.allowMerging = true
    let columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    columnHeaders.columns.forEach((c, index) => {
      c.allowMerging = true
      c.align = "left"

      // 固定部分
      if (
        c.binding === "部所名" ||
        c.binding === "社員コード" ||
        c.binding === "社員氏名"
      ) {
        columnHeaders.setCellData(0, index, "乗務員")
      } else if (
        c.binding === "勤怠日数_出勤" ||
        c.binding === "勤怠日数_祝出" ||
        c.binding === "勤怠日数_休出" ||
        c.binding === "勤怠日数_特休" ||
        c.binding === "勤怠日数_有休"
      ) {
        columnHeaders.setCellData(0, index, "勤怠日数")
        c.align = "right"
      } else if (
        c.binding === "就労時間_勤務時間" ||
        c.binding === "就労時間_残業時間" ||
        c.binding === "就労時間_深夜時間" ||
        c.binding === "就労時間_休出時間"
      ) {
        columnHeaders.setCellData(0, index, "就労時間")
        c.align = "right"
      } else if (c.binding === "支給合計") {
        columnHeaders.setCellData(0, index, "支給合計")
        c.align = "right"
      } else if (
        c.binding?.includes("給与明細_") &&
        c.binding !== "給与明細_旅費" &&
        c.binding !== "給与明細_月報稼働手当" &&
        c.binding !== "給与明細_稼働調整"
      ) {
        columnHeaders.setCellData(0, index, "支給明細")
        c.align = "right"
      } else if (c.binding === "給与明細_旅費") {
        columnHeaders.setCellData(0, index, "控除")
        c.align = "right"
      } else {
        const setHeaderText = c.header ?? ""
        columnHeaders.setCellData(0, index, setHeaderText)
      }
      if (
        c.binding === "給与明細_月報稼働手当" ||
        c.binding === "給与明細_稼働調整"
      ) {
        c.align = "right"
      }
    })

    // ヘッダのみAlignを調整する
    grid.itemFormatter = (panel, r, c, cell) => {
      if (
        panel.cellType === wjGrid.CellType.ColumnHeader &&
        (cell.innerHTML === "控除" ||
          cell.innerHTML === "支給明細" ||
          cell.innerHTML === "給与明細_月報稼働手当" ||
          cell.innerHTML === "給与明細_稼働調整")
      ) {
        cell.style.textAlign = "left"
      } else if (
        panel.cellType === wjGrid.CellType.ColumnHeader &&
        (cell.innerHTML === "勤怠日数" || cell.innerHTML === "就労時間")
      ) {
        cell.style.textAlign = "center"
      }
    }

    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  const beginningEdit = (s: wjGrid.FlexGrid, e: wjGrid.CellRangeEventArgs) => {
    let colBindings =
      (s.columns[e.col].binding as keyof T乗務員給与一覧Grid) ??
      ("" as keyof T乗務員給与一覧Grid)
    let dataItem: T乗務員給与一覧Grid = e.getRow().dataItem
    // 一部手編集可能セル以外は編集不可
    if (
      dataItem.is手当編集Checked &&
      !編集可能CellBindings.includes(colBindings) &&
      colBindings !== "is手当編集Checked"
    ) {
      e.cancel = true
      return
    }
  }

  const pastingCell = beginningEdit

  /**
   * セル編集完了時イベント
   */
  const cellEditEnded = async (
    s: wjGrid.FlexGrid,
    e: wjGrid.CellRangeEventArgs
  ) => {
    let col = s.columns[e.col]

    if (e.cancel === true) {
      return
    }

    switch (col.binding as keyof T乗務員給与一覧Grid) {
      case "給与明細_地域調整手当":
      case "給与明細_業務手当":
        // nullとしたときに0に変換する

        break
      case "is手当編集Checked":
        const dataItems = s.collectionView
          .sourceCollection as T乗務員給与一覧Grid[]
        // データの全体検索を行い編集する人がいないか確認しフラグをONにする
        set更新ボタン押下可能フラグ(dataItems.some((i) => i.is手当編集Checked))
        break
      default:
        break
    }
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      const cellBinding = e.getColumn().binding as keyof T乗務員給与一覧Grid
      const targetRow = e.getRow()
      const dataItem: T乗務員給与一覧Grid = targetRow.dataItem

      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        if (編集可能CellBindings.includes(cellBinding)) {
          wjCore.toggleClass(
            e.cell,
            "read-only-cell",
            !dataItem.is手当編集Checked
          )
        }
      }
    }
  }

  const beforeSubmit = () => {
    // TODO:バリデーションチェック

    setIsConfirmModalShow(true)
  }

  const innerSubmit = async (
    dataList: Array<TZyomuinKyuyoZissekiPutReq>,
    setModal: (a: boolean) => unknown
  ) => {
    try {
      const service = new ZyomuinKyuyoService()
      let res: TApiResponse<boolean>
      res = await service.put(dataList)
      disPatch(setAlerts(res))
      if (res) {
        // if (true) {
        showInfoToast(`給与実績の更新が完了しました。`)
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()
        // リストア中フラグON
        setIsRestoreSearching(true)
        setModal(false)
        // 再検索
        search(querySearchCondition).finally(() => {
          disPatch(画面ロック解除())
          set再計算済みフラグ(false)
        })
      }
    } catch (error) {
      setModal(false)
      disPatch(setAlerts(error))
    }
  }

  const submit = async () => {
    let dataList: Array<TZyomuinKyuyoZissekiPutReq> = []

    // 入力Gridをすべて新規データとしてセットする
    gridData.data.sourceCollection.forEach((d: T乗務員給与一覧Grid) => {
      dataList.push(createRequestData(d))
    })
    await innerSubmit(dataList, setIsConfirmModalShow)
  }

  const beforeSelectedSubmit = () => {
    let dataList: Array<TZyomuinKyuyoZissekiPutReq> = []

    // 業務手当作成のため、選択行のみを一覧化する
    gridData.data.sourceCollection
      .filter((d: T乗務員給与一覧Grid) => d.is手当編集Checked)
      .forEach((d: T乗務員給与一覧Grid) => {
        dataList.push(createRequestData(d))
      })
    setUpdateTargetList([...dataList])
    setIsSelectedConfirmModalShow(true)
  }

  const selectedSubmit = async () => {
    await innerSubmit(updateTargetList, setIsSelectedConfirmModalShow)
  }

  const createRequestData = (
    d: T乗務員給与一覧Grid
  ): TZyomuinKyuyoZissekiPutReq => {
    // 区分から時間取得しているので、実績用にミリ秒変換して返却
    const ミリ秒 = new Decimal(3600000)
    const 勤務時間 = new Decimal(d.就労時間_勤務時間 ?? 0)
    const 残業時間 = new Decimal(d.就労時間_残業時間 ?? 0)
    const 深夜時間 = new Decimal(d.就労時間_深夜時間 ?? 0)
    const 休出時間 = new Decimal(d.就労時間_休出時間 ?? 0)
    const 就労時間 = new Decimal(d.就労時間 ?? 0)

    const t勤務時間 = 勤務時間.times(ミリ秒).toNumber()
    const t残業時間 = 残業時間.times(ミリ秒).toNumber()
    const t深夜時間 = 深夜時間.times(ミリ秒).toNumber()
    const t休出時間 = 休出時間.times(ミリ秒).toNumber()
    const t就労時間 = 就労時間.times(ミリ秒).toNumber()

    return {
      給与実績ID: d.給与実績ID,
      レコード種別: eレコード種別.乗務員給与一覧, // 乗務員なので1固定
      給与支給年月: 年月!,
      社員ID: d.社員ID,

      出勤日数: d.出勤日数 ?? 0,
      休出日数: d.休出日数 ?? 0,
      祝出日数: d.祝出日数 ?? 0,
      特休日数: d.特休日数 ?? 0,
      有休日数: d.有休日数 ?? 0,

      就労時間: t就労時間,
      勤務時間: t勤務時間,
      残業時間: t残業時間,
      深夜時間: t深夜時間,
      休出時間: t休出時間,
      運行外日数: 0, // 使用しなくなったので仮で０設定
      稼働手当: d.給与明細_稼働手当,
      残業手当: d.給与明細_残業手当,
      基本給: d.給与明細_基本給,
      有休補償: d.給与明細_有休補償,
      通勤手当課: d.給与明細_通勤手当課,
      通勤手当非: d.給与明細_通勤手当非,

      休日手当: d.給与明細_休日手当,
      地域調整手当: d.給与明細_地域調整手当,
      旅費: d.給与明細_旅費,
      月報稼働手当: d.給与明細_月報稼働手当,
      稼働調整: d.給与明細_稼働調整,
      残業割増額: d.給与明細_残業割増額,
      深夜割増額: d.給与明細_深夜割増額,
      休日割増額: d.給与明細_休日割増額,

      住宅手当: d.給与明細_住宅手当,
      能力開発: d.給与明細_能力開発,
      業務手当: d.給与明細_業務手当,
      評価割増: d.給与明細_評価割増,
      削除フラグ: 0,
      更新日時: d.給与実績_更新日時,

      所定時間マスタ_更新日時: d.所定時間マスタ_更新日時,
      稼働調整_更新日時: d.稼働調整_更新日時,
      乗務員給与_更新日時: d.乗務員給与_更新日時,
    }
  }

  const downloadCsv = async () => {
    const service = new ZyomuinKyuyoService({ responseType: "blob" })

    try {
      const blob = await service.downloadCsv({
        年月: preSearchCondition?.年月!,
      })
      saveAs(
        blob,
        `乗務員給与_OBIC連携_${dayjs().format("YYYYMMDDHHmmss")}.csv`
      )
    } catch (err) {
      disPatch(setAlerts(err))
    } finally {
      setIsDownloadCsvConfirmModalShow(false)
    }
  }

  const 再計算ボタンClickHandler = () => {
    // 支給明細の項目をPG計算しなおし
    if (!flexGrid) return

    // 表示ページ以外のItemsSourceも更新するため、GridDataを入れ替えする。
    let dataList: Array<TZyomuinKyuyoInfoGetRes> = []
    gridData.data.sourceCollection.forEach((dataItem: T乗務員給与一覧Grid) => {
      // 表示上の実績データは過去に計算されたものであるため
      // 最新の収集された情報で更新するために給与実績の計算項目をundefinedに上書きする
      let data: T乗務員給与 & Partial<IGridFields> = {
        // 実績以外の情報はそのまま
        乗務員ID: dataItem.乗務員ID,
        社員ID: dataItem.社員ID,
        部所ID: dataItem.部所ID,
        部所コード: dataItem.部所コード,
        部所名: dataItem.部所名,
        社員コード: dataItem.社員コード,
        社員氏名: dataItem.社員氏名,
        出勤日数: dataItem.出勤日数,
        休出日数: dataItem.休出日数,
        祝出日数: dataItem.祝出日数,
        特休日数: dataItem.特休日数,
        有休日数: dataItem.有休日数,
        就労時間: dataItem.就労時間,
        深夜時間: dataItem.深夜時間,
        休出時間: dataItem.休出時間,
        日曜出勤数: dataItem.日曜出勤数,
        所定時間ID: dataItem.所定時間ID,
        所定時間マスタ_所定時間: dataItem.所定時間マスタ_所定時間,
        所定時間マスタ_更新日時: dataItem.所定時間マスタ_更新日時,
        取込_稼働調整: dataItem.取込_稼働調整,
        稼働調整_更新日時: dataItem.稼働調整_更新日時,
        乗務員給与ID: dataItem.乗務員給与ID,
        乗務員給与_基本給: dataItem.乗務員給与_基本給,
        乗務員給与_時間外単価: dataItem.乗務員給与_時間外単価,
        乗務員給与_深夜残単価: dataItem.乗務員給与_深夜残単価,
        乗務員給与_日曜残単価: dataItem.乗務員給与_日曜残単価,
        乗務員給与_休日手当: dataItem.乗務員給与_休日手当,
        乗務員給与_通勤費_課税: dataItem.乗務員給与_通勤費_課税,
        乗務員給与_通勤費_非課税: dataItem.乗務員給与_通勤費_非課税,
        乗務員給与_評価割増: dataItem.乗務員給与_評価割増,
        乗務員給与_住宅手当: dataItem.乗務員給与_住宅手当,
        乗務員給与_能力開発: dataItem.乗務員給与_能力開発,
        乗務員給与_業務手当: dataItem.乗務員給与_業務手当,
        乗務員給与_その他手当: dataItem.乗務員給与_その他手当,
        乗務員給与_更新日時: dataItem.乗務員給与_更新日時,
        食事手当: dataItem.食事手当,
        稼働手当: dataItem.稼働手当,
        特別手当: dataItem.特別手当,
        その他手当: dataItem.その他手当,

        // 編集済フラグ
        is手当編集Checked: dataItem.is手当編集Checked,
        //地域調整手当は基本実績として入力されたものをそのまま利用する
        給与明細_地域調整手当: dataItem.給与明細_地域調整手当,

        // 実績情報をclear
        実績表示フラグ: 0,
        給与実績ID: dataItem.給与実績ID,
        レコード種別: dataItem.レコード種別,
        給与支給年月: dataItem.給与支給年月,
        給与実績_出勤日数: undefined,
        給与実績_休出日数: undefined,
        給与実績_祝出日数: undefined,
        給与実績_特休日数: undefined,
        給与実績_有休日数: undefined,
        給与実績_就労時間: undefined,
        給与実績_勤務時間: undefined,
        給与実績_残業時間: undefined,
        給与実績_深夜時間: undefined,
        給与実績_休出時間: undefined,
        給与実績_残業手当: undefined,
        給与実績_基本給: undefined,
        給与実績_有休補償: undefined,
        給与実績_通勤手当課: undefined,
        給与実績_通勤手当非: undefined,
        給与実績_休日手当: undefined,
        給与実績_地域調整手当: undefined,
        給与実績_旅費: undefined,
        給与実績_月報稼働手当: undefined,
        給与実績_稼働調整: undefined,
        給与実績_稼働手当: undefined,
        給与実績_残業割増額: undefined,
        給与実績_深夜割増額: undefined,
        給与実績_休日割増額: undefined,
        給与実績_住宅手当: undefined,
        給与実績_能力開発: undefined,
        給与実績_業務手当: undefined,
        給与実績_評価割増: undefined,
        給与実績_削除フラグ: undefined,
        給与実績_更新日時: dataItem.給与実績_更新日時,
      }
      //稼働手当を再計算する
      //編集チェックが入っているものはそのまま移し替える
      if (data.is手当編集Checked) {
        data.給与明細_業務手当 = dataItem.給与明細_業務手当
      } else {
        data.給与明細_業務手当 = calc給与明細_業務手当(data)
      }
      dataList.push(data)
    })
    const newGridData = {
      data: createCollectionView(dataList, pageSize),
    }
    setGridData(newGridData)

    // flexGrid.itemsSource = newGridData.data
    flexGrid?.refresh()
    showInfoToast(`支給明細 の再計算が完了しました。`)
    set再計算済みフラグ(true)
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中
  const [isSearched, setIsSearched] = useState(false) // 検索完了

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const disPatch: AppDispatch = useDispatch()

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  const [isSelectedConfirmModalShow, setIsSelectedConfirmModalShow] =
    useState(false)
  const [isKadoTyoseiModalShow, setIsKadoTyoseiModalShow] =
    useState<boolean>(false)
  const [isDownloadCsvConfirmModalShow, setIsDownloadCsvConfirmModalShow] =
    useState(false)
  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)
  const [searchDataInitialized, setSearchDataInitialized] =
    useState<boolean>(false)

  // モーダル側との検索動作判定用
  const [preSearchCondition, setPreSearchCondition] =
    useState<TZyomuinKyuyoListGetReq>({} as TZyomuinKyuyoListGetReq)

  // ボタン制御
  const [再計算済みフラグ, set再計算済みフラグ] = useState<boolean>(false)
  const [更新ボタン押下可能フラグ, set更新ボタン押下可能フラグ] =
    useState(false)

  //#endregion

  //#region [state]
  const [年月, set年月] = useState<string | null>()
  const [updateTargetList, setUpdateTargetList] = useState<
    TZyomuinKyuyoZissekiPutReq[]
  >([])

  // combobox
  // 部所
  const [部所コード, set部所コード] = useState<string | null>()
  const [, set部所] = useState<T部所マスタ | null>()
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    T部所マスタ["部所コード"],
    T部所マスタ
  > | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)

  //#endregion

  //#region [effect]
  // APIからItemSourceを取得
  useEffect(() => {
    Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
      set部所ItemSource(部所ListRes.data)
      setSearchDataInitialized(true)
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && searchDataInitialized && 部所ComboBox) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          disPatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        disPatch(画面ロック解除())
      }
    }
  }, [gridInitialized, searchDataInitialized, 部所ComboBox])

  useEffect(() => {
    document.title = `乗務員給与一覧`
    // 初期表示生成のため画面ロック
    disPatch(画面ロック開始())

    // 年月を初期設定
    set年月(eigyobi)
  }, [])
  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">乗務員給与一覧</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card>
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body id="collapse-search-card-body">
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <div className="w-10rem">
                              <MonthInput
                                autoFocus
                                id="年月"
                                value={年月}
                                setValue={set年月}
                                isRequired={true}
                                placeholder="年月"
                              />
                            </div>

                            <ComboBox.Busyo
                              placeholder="部所"
                              isAllSelect={true}
                              itemsSource={部所ItemSource}
                              isLoadEnded={部所IsLoadEnded}
                              setIsLoadEnded={set部所IsLoadEnded}
                              setSelectedValue={set部所コード}
                              listFilter={(d) => d.運行部所フラグ === 1}
                              selectedValue={部所コード}
                              setSelectedItem={set部所}
                              ComboBox={部所ComboBox}
                              setComboBox={set部所ComboBox}></ComboBox.Busyo>
                          </div>
                        </div>
                        <Button
                          type="submit"
                          disabled={isSearching}
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            // storeを初期化する
                            disPatch(zyomuinKyuyoActions.init())
                            search()
                          }}>
                          <FontAwesomeIcon icon={faSearch} />
                          検索
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                isShowGridRowPickupButton={false}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                gridProperties={{
                  frozenColumns: 4,
                  isReadOnly: false, // 編集可能
                  beginningEdit,
                  pastingCell,
                  cellEditEnded,
                }}
                headerComponent={
                  <>
                    <Button
                      disabled={!isSearched}
                      type="submit"
                      variant="waiting"
                      onClick={再計算ボタンClickHandler}>
                      支給明細 画面再計算
                    </Button>

                    <Button
                      disabled={
                        !isSearched ||
                        !再計算済みフラグ ||
                        !更新ボタン押下可能フラグ
                      }
                      variant="waiting"
                      type="submit"
                      onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        beforeSelectedSubmit()
                      }}>
                      <FontAwesomeIcon icon={faPlusSquare} />
                      選択社員手当更新実行
                    </Button>

                    <Button
                      disabled={!isSearched || !再計算済みフラグ}
                      type="submit"
                      variant="waiting"
                      onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        beforeSubmit()
                      }}>
                      <FontAwesomeIcon icon={faPlusSquare} />
                      給与計算実績登録
                    </Button>

                    {/* Excelコピペ貼り付け用Modal呼び出し */}
                    <Button
                      disabled={!isSearched}
                      className="ms-5"
                      type="submit"
                      variant="primary"
                      onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        setIsKadoTyoseiModalShow(true)
                      }}>
                      <FontAwesomeIcon icon={faPlusSquare} />
                      稼働調整 Excel貼り付け
                    </Button>

                    <Button
                      disabled={!isSearched || 再計算済みフラグ}
                      className="btn-done"
                      type="submit"
                      onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        setIsDownloadCsvConfirmModalShow(true)
                      }}>
                      <FontAwesomeIcon icon={faFileAlt} />
                      OBC連携CSV作成
                    </Button>
                  </>
                }>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  allowDragging={false}
                  binding="部所名"
                  width={140}
                  sortMemberPath="sort_部所コード"
                  header="部所"
                  isReadOnly></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  allowDragging={false}
                  binding="社員コード"
                  width={100}
                  sortMemberPath="sort_社員コード"
                  header="社員番号"
                  isReadOnly></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  allowDragging={false}
                  binding="社員氏名"
                  width={128}
                  header="氏名">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TZyomuinKyuyoInfoGetRes>
                    ) => {
                      return context.item.給与支給年月 &&
                        dayjs(context.item.給与支給年月).isValid() ? (
                        <a
                          className="text-center text-primary"
                          target="_blank"
                          rel="noreferrer"
                          href={generatePath(
                            util.getMenuPath(
                              メニューコード.勤怠管理.乗務員出勤簿
                            )[0],
                            {
                              id: context.item.社員ID,
                              date: dayjs(context.item.給与支給年月).format(
                                "YYYY-MM-DD"
                              ),
                            }
                          )}>
                          {context.item.社員氏名}
                        </a>
                      ) : (
                        <>{context.item.社員氏名}</>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  variant="waiting"
                  header="手当編集"
                  wordWrap={true}
                  dataType={wjCore.DataType.Boolean}
                  allowDragging={false}
                  hasFilter={false}
                  allowSorting={false}
                  isReadOnly={false}
                  binding="is手当編集Checked"
                  allowMerging={true}
                  selectable={false}
                  align="center"
                  width={60}></wjrGrid.FlexGridColumn>
                {/* 勤怠日数 */}
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="勤怠日数_出勤"
                  width={80}
                  format="N2"
                  header="勤務"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="勤怠日数_休出"
                  width={80}
                  format="N2"
                  header="休出"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="勤怠日数_祝出"
                  width={80}
                  format="N2"
                  header="祝出"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="勤怠日数_特休"
                  width={80}
                  format="N0"
                  header="特休"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="勤怠日数_有休"
                  width={80}
                  format="N0"
                  header="有休"></wjrGrid.FlexGridColumn>
                {/* 就労時間 */}
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="就労時間_勤務時間"
                  width={80}
                  isReadOnly
                  header="勤務"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="就労時間_残業時間"
                  width={80}
                  header="残業"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="就労時間_深夜時間"
                  // format="N2"
                  width={80}
                  header="深夜"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="就労時間_休出時間"
                  width={80}
                  header="休出"></wjrGrid.FlexGridColumn>

                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="支給合計"
                  format="N0"
                  dataType={wjCore.DataType.Number}
                  width={100}
                  header="支給合計"></wjrGrid.FlexGridColumn>

                {/* 給与実績 */}
                {/* 表示値について：給与実績IDあり⇒DB値　なし⇒PG計算 */}
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="給与明細_基本給"
                  format="N0"
                  width={100}
                  header="基本給"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="給与明細_住宅手当"
                  format="N0"
                  width={130}
                  header="住宅手当"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="給与明細_能力開発"
                  format="N0"
                  width={130}
                  header="能力開発手当"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="給与明細_地域調整手当"
                  isRequired={false}
                  format="N0"
                  width={130}
                  header="地域調整手当"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="給与明細_稼働手当"
                  format="N0"
                  width={100}
                  header="稼働手当"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="給与明細_残業手当"
                  format="N0"
                  width={130}
                  header="残業手当"></wjrGrid.FlexGridColumn>
                {/* 残業の内訳 */}
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="給与明細_残業割増額"
                  format="N0"
                  width={130}
                  header="残業割増額"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="給与明細_深夜割増額"
                  format="N0"
                  width={130}
                  header="深夜割増額"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="給与明細_休日割増額"
                  format="N0"
                  width={130}
                  header="休日割増額"></wjrGrid.FlexGridColumn>

                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="給与明細_業務手当"
                  isRequired={false}
                  format="N0"
                  width={100}
                  header="業務手当"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="給与明細_休日手当"
                  format="N0"
                  width={130}
                  header="休日手当"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="給与明細_評価割増"
                  format="N0"
                  width={130}
                  header="評価割増"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="給与明細_有休補償"
                  format="N0"
                  width={100}
                  header="有休補償"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="給与明細_通勤手当課"
                  format="N0"
                  width={130}
                  header="通勤費（課）"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="給与明細_通勤手当非"
                  format="N0"
                  width={130}
                  header="通勤費（非）"></wjrGrid.FlexGridColumn>

                {/* 控除 */}
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="給与明細_旅費"
                  format="N0"
                  width={150}
                  header="食事手当（旅費）"></wjrGrid.FlexGridColumn>

                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="給与明細_月報稼働手当"
                  format="N0"
                  width={130}
                  header="月報稼働手当"></wjrGrid.FlexGridColumn>
                {/* EXCEL取込 */}
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="給与明細_稼働調整"
                  format="N0"
                  width={130}
                  header="稼働調整額"></wjrGrid.FlexGridColumn>
                {/* 
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="給与明細_残業割増額"
                  format="N0"
                  width={130}
                  header="残業割増額"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="給与明細_深夜割増額"
                  format="N0"
                  width={130}
                  header="深夜割増額"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="給与明細_休日割増額"
                  format="N0"
                  width={130}
                  header="休日割増額"></wjrGrid.FlexGridColumn> */}
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <FunctionContext.Provider
        value={() => {
          search(preSearchCondition)
        }}>
        {/* 稼働調整貼り付け */}
        <KadoTyoseiRegisterModal
          isShow={isKadoTyoseiModalShow}
          setIsShow={(v) => {
            setIsKadoTyoseiModalShow(v)
          }}
          年月={ref年月.current ?? eigyobi}
          登録更新="登録"></KadoTyoseiRegisterModal>
      </FunctionContext.Provider>
      {/* 給与計算実行 */}
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        <div>入力された計算内容で登録しますか？</div>
        <div className="text-danger">
          ※画面に表示されている内容で地域調整手当・業務手当も登録されます。
        </div>
      </ConfirmModal>
      <ConfirmModal
        isShow={isDownloadCsvConfirmModalShow}
        hideHandler={setIsDownloadCsvConfirmModalShow}
        submitHandler={downloadCsv}>
        <div>OBIC連携用CSVを出力しますか？</div>
        <div className="text-danger">
          最後に計算された給与内容で出力されます。
        </div>
        <div className="text-danger">最新の計算結果で出力する場合、</div>
        <div className="text-danger">
          再計算後給与実績登録を行った上で出力を行ってください。
        </div>
      </ConfirmModal>
      <ConfirmModal
        isShow={isSelectedConfirmModalShow}
        hideHandler={setIsSelectedConfirmModalShow}
        submitHandler={selectedSubmit}>
        <div className="mb-1">以下の乗務員の計算内容を更新します。</div>
        {updateTargetList.map((t) => {
          const 列情報 = gridData.data.sourceCollection.find(
            (i: T乗務員給与一覧Grid) => t.社員ID === i.社員ID
          ) as T乗務員給与一覧Grid
          return (
            <div key={列情報?.社員ID}>
              {列情報.社員コード}:{列情報.社員氏名}
            </div>
          )
        })}
        <div className="mt-1">よろしいですか？</div>
      </ConfirmModal>
    </Container>
  )
}

export default ZyomuinKyuyoList
